module.exports = __webpack_public_path__ + "static/media/Logo-grey-qempo.4a96a836.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Logo-grey-qempo.png
// module id = 1246
// module chunks = 0